import Home from './Home.tsx';

function HomeWrapper() {
   return (
      <div style={{ backgroundColor: 'black' }}>
         <span style={{ color: 'white' }}>
            Any issues please hit me up via mjrule888@hotmail.com
         </span>
         <Home />
      </div>
   );
}

export default HomeWrapper;
